import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > Math.max(500, window.innerHeight * 0.7));
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      aria-label="Go to top"
      onClick={() => window.scrollTo({ top: 0, left: 0, behavior: "smooth" })}
      className="fixed bottom-20 right-5 z-40 grid h-11 w-11 place-items-center border border-orange-500 bg-black text-orange-500 shadow-2xl shadow-black/40 transition-colors hover:bg-orange-500 hover:text-black"
    >
      <ArrowUp className="h-5 w-5" />
    </button>
  );
}
